import React from "react";
import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useAdmin from "./useAdmin";

const Admin = () => {
  const { drawerMenu } = useAdmin();
  return (
    <CommonLayout drawerMenu={drawerMenu} >
      <Outlet />
    </CommonLayout>
  );
};

export default Admin;
